import * as React from 'react'
import { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
// evertel
import { useService } from '@evertel/di'
import { Modal, ModalBody, ModalHeader, ModalFooter, Row, Col, InfoBox, Button, Text, PasswordInput } from '@evertel/web/ui'
import { AuthenticationController } from '@evertel/shared/feature-authentication-auth0'
import { Analytics } from '@evertel/analytics'
import { SessionService } from '@evertel/session/SessionService'
import { DeviceTokenService } from '@evertel/session/DeviceTokenService'
import { CurrentUserController } from '@evertel/blue-user'

interface Props {
    isOpen: boolean
    onClose: () => void
    authenticatorId: string
}

const Unenroll2FAModal: React.FC<Props> = observer(({
    isOpen = false,
    authenticatorId,
    onClose
}) => {

    const analytics = useService(Analytics)
    const sessionService = useService(SessionService)
    const currentUserController = useService(CurrentUserController, [sessionService.currentUserId])


    const deviceTokenService = useService(DeviceTokenService, [])
    const authenticationController = useService(AuthenticationController)

    const [error, setError] = useState<string | null>(null)
    const [password, setPassword] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (isOpen) {
            // reset state
            setError(null)
            setPassword('')
            setIsLoading(false)

            analytics.logView('/account/security/unenroll-mfa', true)
        }
    }, [isOpen])

    const submitUnenrollMfa = async () => {
        setError(null)

        if (!password?.trim()) {
            setError('You must enter your password to unenroll in SMS')
            return
        }

        setIsLoading(true)

        try {
            await authenticationController.deleteAuthenticator(
                currentUserController.user.id,
                authenticatorId,
                currentUserController.user.email,
                password.trim(),
                deviceTokenService.token
            )

            onClose()

        } catch (err: any) {
            setError(authenticationController.formatEnrollmentError(err))
        }
        finally {
            setIsLoading(false)
        }
    }

    const onChangePassword = (value: string) => {
        setPassword(value)
    }

    const authenticator = authenticationController.findAuthenticatorById(authenticatorId)

    return (
        <Modal
            visible={isOpen}
            className="join-dept-modal"
            onClose={onClose}
        >
            <ModalHeader title="Unenroll in SMS Authentication" />
            <ModalBody>
                <Row>
                    <Col>
                        {(error) &&
                            <InfoBox color="danger">
                                {error}
                            </InfoBox>
                        }

                        <Text className="pb-4">
                            Please enter your password to unenroll: {authenticator?.name}
                        </Text>

                        <PasswordInput
                            label="Current Password"
                            value={password}
                            disabled={isLoading}
                            onChange={onChangePassword}
                            placeholder="Type your current password"
                        />
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter className="text-center">
                <Row align="right">
                    <Col>
                        <Button
                            color="primary"
                            onClick={submitUnenrollMfa}
                            disabled={isLoading}
                            loading={isLoading}>
                            <Text>Unenroll</Text>
                        </Button>
                    </Col>
                </Row>
            </ModalFooter>
        </Modal>
    )
})

export {
    Unenroll2FAModal
}
